import PersonalMemoProvider,{memoTargetForChat} from '../../personalMemos/PersonalMemoProvider';
import React, { createContext, useContext } from 'react';
import useChatTopicSelection from './useChatTopicSelection';
import ChatTopicModal from './ChatTopicModal';
import '../../../../css/common/chat/ChatTopics.css';

const ChatTopicsContext = createContext<any>(null);
export const useChatTopicsContext = () => useContext(ChatTopicsContext);
export function useChatSelectionBack(onBack: (...args: any[]) => void) {
  const topics = useChatTopicsContext();
  return (...args: any[]) => { if (!topics?.selection?.consumeBack()) onBack?.(...args); };
}
export function ChatTopicsProvider({ value, children }: { value: any; children: React.ReactNode }) {
  const selection = useChatTopicSelection(value);
  const controller = { ...value, selection, assignment: selection.picker ? selection : null,
    open: value.open || selection.picker, closePicker: selection.picker ? selection.closePicker : value.closePicker };
  const content=<>{children}<ChatTopicModal topics={controller} /></>;
  return <ChatTopicsContext.Provider value={controller}>
    {['admin','artist'].includes(value.actorType||value.role)?<PersonalMemoProvider key={value.parentKey} actor={value.actorType||value.role} ownerKey={String(value.parentKey||'').split(':').slice(0,2).join(':')} current={memoTargetForChat(value.scope,value.conversationId)}>{content}</PersonalMemoProvider>:content}
  </ChatTopicsContext.Provider>;
}
